import { HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Field } from 'src/app/shared/models/field.model';

const API_GET_ENTERPRISE = '/enterprises/dc-enterprise/';
const API_GET_CUSTOMERS = '/customer/dc-customers';
const API_MERGE_DATA_TO_FILE = '/dc/files/merge-data-to-file';

export interface NegotiationFieldValue {
    fieldId: string;
    value: any;
    valueId: any;
    children: NegotiationFieldValue[];
}

@Injectable({
    providedIn: 'root'
})
export class TemplateFormService {

    constructor(private apiService: ApiService) { }

    getEnterprise(id: string): Observable<any> {
        return this.apiService.get(`${API_GET_ENTERPRISE}${id}`);
    }

    getCustomers(ids: string[]): Observable<any> {
        return this.apiService.post(API_GET_CUSTOMERS, ids);
    }

    mergeDataToFile(body: {list: Field[], url: string, code: string, documentTypeEnterpriseId: string, isNegotiate?: boolean}): Observable<any> {
        return this.apiService.getFilePostMethod(API_MERGE_DATA_TO_FILE, body);
    }

    updateNegotiationForm(body: {contractId: string, filePath: string, fields: NegotiationFieldValue[]}): Observable<any> {
        return this.apiService.post('/contract/negotiate/form/update', body);
    }
}
